import { css } from 'lit'
import 'urlpattern-polyfill'
import { html } from 'lit/static-html.js'
import RouterElement from '../router/element.js'

/**
 * Router element
 * renders the current route
 * @extends
 * @extends RouterElement
 * @customElement
 *
 * @example
 * <hh-quiz-router-view />
 *
 */
class HHQuizRouterView extends RouterElement {
  /**
   * Renders the current route with the view
   * @returns {TemplateResult}
   */
  render() {
    return html`${this.renderRoute()}`
  }

  /**
   * Focuses the first focusable element
   */
  updated() {
    this.focusFirstWithin()
    super.updated()
  }

  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  `
}

customElements.define('hh-quiz-router-view', HHQuizRouterView)
